import { createSlice } from "@reduxjs/toolkit";
import * as persistenceActionTypes from "store/actions/persistence/persistenceActionTypes";

const initialState = { exposures: [] };

const glExposuresSlice = createSlice({
  name: "glExposures",
  initialState,
  reducers: {
    setGlExposures: (state, action) => {
      const values = action?.payload ?? {};
      if (values?.constructor?.name !== "Object") {
        return;
      }
      return {
        ...initialState,
        ...values,
      };
    },
    updateGlExposures: (state, action) => {
      const values = action?.payload;
      if (values?.constructor?.name !== "Object") {
        return;
      }
      return {
        ...state,
        ...values,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      persistenceActionTypes.LOAD_SUBMISSION_SUCCEEDED,
      (_, action) => action?.payload?.data?.state?.glExposures ?? initialState
    );
  },
});

export const selectGlExposuresInput = (state) => state?.glExposures ?? null;

export const selectExposures = (state) => state?.glExposures?.exposures ?? [];

export const selectResolvedGlExposures = (state) =>
  selectExposures(state).map(
    ({
      id: _id,
      classCode,
      exposureAmount,
      territory: _territory,
      lcm: _lcm,
      territoryFactor: _territoryFactor,
      ...rest
    }) => ({
      ...rest,
      class_code: classCode,
      exposure_amount: exposureAmount,
    })
  );

export const {
  setGlExposures: set,
  updateGlExposures: update,
} = glExposuresSlice.actions;

export default glExposuresSlice;
